import { Phone, Mail } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTACT } from "../data/site";

export const CtaBand = ({ title = "Deploy security anywhere in Scotland", sub = "Free risk assessment. Honest recommendations. A written plan we can be held to — call or email our 24/7 command centre." }) => (
    <section className="bg-[#0F1117] border-y border-white/10 xp-grain relative" data-testid="cta-band">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20 text-center">
            <Reveal>
                <p className="font-mono-xp text-[11px] uppercase tracking-[0.3em] text-[#E53E3E] mb-4">Get Protected</p>
                <h2 className="font-display uppercase font-extrabold text-4xl sm:text-5xl tracking-wide text-white leading-none max-w-3xl mx-auto">
                    {title}
                </h2>
                <p className="text-gray-400 text-sm sm:text-base leading-relaxed mt-5 max-w-xl mx-auto">{sub}</p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-9">
                    <a
                        href={CONTACT.phoneHref}
                        data-testid="cta-phone-button"
                        className="xp-glow flex items-center gap-3 bg-[#E53E3E] hover:bg-[#c93636] transition-colors duration-300 text-white font-mono-xp text-sm uppercase tracking-widest px-8 py-4"
                    >
                        <Phone size={16} /> {CONTACT.phone}
                    </a>
                    <a
                        href={CONTACT.emailHref}
                        data-testid="cta-email-button"
                        className="flex items-center gap-3 border border-white/25 hover:border-[#E53E3E] hover:text-[#E53E3E] transition-colors duration-300 text-white font-mono-xp text-sm uppercase tracking-widest px-8 py-4"
                    >
                        <Mail size={16} /> Email Our Team
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);
